module.exports = __webpack_public_path__ + "static/media/tour-produto-3.44719c3b.png";